import React from 'react'
import PropTypes from 'prop-types'
import css from './style.css'
import Spacer from '../spacer'

const PageTitle = props => {
  const classNames = [
    css.headline,
    props.lg ? css.lg : ''
  ].join(' ')

  return (
    <div className={css.container}>
      <Spacer xs />
      <h1 className={classNames}>
        {props.children}
        <small className={css.title}>
          {props.title && <span style={{background: props.background ? `${props.background}` : ''}}>{props.title}</span>}
        </small>
      </h1>
      {props.subtitle ? <h2 className={css.subtitle}>{props.subtitle}</h2> : <Spacer sm />}
    </div>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  lg: PropTypes.bool,
  background: PropTypes.string
}

export default PageTitle



// WEBPACK FOOTER //
// ./src/components/page-title/index.js